export default __webpack_public_path__ + "assets/1c4a750c249a8aaa1cf43de4a23ef0b0.png";